export const getFailureDisplayMessage = (message: string) => {
  switch (message) {
    case 'Invalid search query format':
      return 'Oops! It looks like your search query is missing some details. Add at least one contact property or custom event to continue.';
    case 'missing input value':
      return "Oops! It seems you're missing a value in your criteria. Fill in the empty field to continue.";
    case 'merge parameter(s) are not allowed':
      return "Oops! Merge parameters aren't supported here. Remove them and try again.";
    case 'invalid regex input':
      return "Hmm... it looks like there's an issue with your regex input. Double-check it and try again.";
    default:
      return message;
  }
};
